<div v-if="shouldRenderConfig && !getIsMyAccount && getShowConnectButton" v-bind:class="getClassName">
    <button type="button" class="btn btn-primary" v-bind:class="getDisableClass" v-on:click="connectButton">
        {{ $t(name) }}
    </button>    
</div>

